import React from "react";
import { createRoot } from "react-dom/client";
import Root from "root/Root";
import configureStore from "configureStore";

const { store, history } = configureStore();
const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(<Root store={store} history={history} />);
